'use client';

import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import Image from 'next/image';
import { BLUR_DATA_URL } from '../../util/imageConstants';
import { getIconSize } from './infoTile.util';
import { getRunTimeEnv } from '../../util/getEnvVariable';

/**
 * @name InfoTileIcon
 * @param {object} props - Strapi Data
 * @returns {JSX.Element} - Renders Next js Image component
 */
const InfoTileIcon = props => {
  const theme = useTheme();
  const sm = useMediaQuery(theme.breakpoints.down('sm'));
  const clientSideEnv = getRunTimeEnv();

  return (
    <Image
      placeholder={props.tileIcon ? 'empty' : 'blur'}
      blurDataURL={BLUR_DATA_URL}
      width={getIconSize(props?.tileIcon, sm)}
      height={getIconSize(props?.tileIcon, sm)}
      src={`${clientSideEnv.NEXT_PUBLIC_STRAPI_SERVER || process.env.NEXT_PUBLIC_STRAPI_SERVER}${props?.icon?.data?.attributes?.url}`}
      alt={props?.icon?.data?.attributes?.alternativeText}
      style={{
        objectFit: 'cover',
        transition: 'opacity 0.3s ease',
      }}
      quality={100}
    ></Image>
  );
};
InfoTileIcon.displayName = 'InfoTileIcon';
export default InfoTileIcon;
